import Spinner from './view/desktop';
export default Spinner;
